import { render } from "./Item6.vue?vue&type=template&id=832139e8"
import script from "./Item6.vue?vue&type=script&lang=ts"
export * from "./Item6.vue?vue&type=script&lang=ts"
script.render = render

export default script